import { Reveal } from "@/components/Section";

export function AppIntelligence() {
  return (
    <section className="border-t border-zinc-800 bg-[#0a0a0a]" data-testid="home-app-intelligence">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-accent block mb-6">Platform Capabilities in Development</span>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light tracking-tighter leading-[1.05] max-w-3xl">
            What the WearSpray platform is{" "}
            <span className="text-accent">being built to do.</span>
          </h2>
          <p className="font-body text-zinc-400 text-lg leading-relaxed mt-7 max-w-2xl">
            Over months and years it builds a longitudinal picture, your products,
            your skin preferences, your application history, your routines and
            your conversations with the AI, becoming a personal skin resource
            that is genuinely yours.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {[
            ["Nudges your wrist when it's time to act", "The heart of WearSpray. It nudges you when your selected routine or contextual reminder suggests it may be time to reapply, and the formula is already on your wrist. Sense → Understand → Prompt → Act → Learn.", true],
            ["Talks like a smart, calm expert", "An AI assistant turns the data into one plain-English headline and a personalized tip, tailored to your skin and current conditions."],
            ["Learns your skin, once", "Build your personal skin profile: tone and sun sensitivity, any sensitivities, your goals and preferred SPF. Update it anytime."],
            ["Remembers your routine", "Planned application logging through user confirmation, with automatic dispensing detection subject to further development. It keeps track of the formula loaded in your device, so refilling is a single tap."],
          ].map(([title, body, star], i) => (
            <Reveal key={title} delay={i * 0.06}>
              <div className={`h-full border p-6 ${star ? "border-accent/50 bg-accent/[0.04]" : "border-zinc-800 bg-white/[0.02]"}`} data-testid={`app-today-${i + 1}`}>
                <div className="flex items-center gap-3 mb-3">
                  <span className={`font-mono text-sm ${star ? "text-accent" : "text-zinc-500"}`}>{String(i + 1).padStart(2, "0")}</span>
                  {star && <span className="text-accent text-sm">★</span>}
                </div>
                <h4 className="font-heading text-lg font-medium text-white leading-tight">{title}</h4>
                <p className="font-body text-zinc-400 text-sm leading-relaxed mt-2">{body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
